import styled from "@emotion/styled";
import { Box, Paper } from "@mui/material";

export const PageContainer = styled(Box)`
    width: 100%;
    display: flex;
    flex-direction: column;
    padding: 2rem;
    
    @media (max-width: 768px) {
        padding: 1rem;
    }
`

export const ContentContainer = styled(Box)`
    width: 100%;
    display: grid;
    grid-template-columns: 1fr 400px;
    gap: 2rem;
    margin-top: 2rem;

    @media (max-width: 1280px) {
        grid-template-columns: 1fr;
    }
`

export const FormContainer = styled(Box)`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 1rem;
`

export const ResumoPaper = styled(Paper)`
    padding: 2rem;
    display: flex;
    flex-direction: column;
    height: fit-content;
    position: sticky;
    top: 70px;

    @media (max-width: 1280px) {
        position: relative;
        top: 0;
    }
`

export const ButtonsContainer = styled(Box)`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 2rem;
    gap: 1rem;
    
    button {
        flex: 1;
        max-width: 200px;
    }

    @media (max-width: 768px) {
        flex-direction: column;
        
        button {
            max-width: 100%;
            width: 100%;
        }
    }
`

export const PreviewContainer = styled(Box)`
    display: flex;
    flex-direction: column;
    gap: 1rem;
    padding: 1rem;
    border-radius: 8px;
    background-color: ${props => props.theme.palette.background.default};
`

export const LogoPreview = styled(Box)`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 2rem;
    
    img {
        max-width: 150px;
        max-height: 150px;
        object-fit: contain;
    }
`

